import React from 'react'
import { Section } from "../../ui"
import WhoWeArePNG from '../../../assets/images/whoWeAre.png'
import './whoWeAre.scss'

const WhoWeAreSection = () => {

    return (
        <Section>
            <div className="whoWeAre-wrapper">
                <img src={WhoWeArePNG}/>
                <div className="whoWeAre-content_container">
                    <h2 className="whoWeAre-title">Who we are</h2>
                    <p className="whoWeAre-description">We are a team of film producers and Web3 developers with years of deep experience in Web3 and global Entertainment spaces. We believe in the power of Web3 technology to create collaboratively-owned peer-to-peer structures that will redefine the Entertainment and Media landscape. Creating hashrate Studios is the first step we are taking on our mission to co-create the Entertainment ecosystem of tomorrow. Join us today!</p>
                </div>
            </div>
        </Section>
    )
}

export default WhoWeAreSection